up.compiler('[copyright-notice]', function(element) {
  const originalYear = 2023
  const currentYear = new Date().getFullYear()
  const yearString = originalYear === currentYear ? currentYear.toString() : `${originalYear}-${currentYear}`

  element.innerText = `© ${yearString} Dominic Beger Software Solutions`
})